export default "__VITE_PUBLIC_ASSET__4b2e54ba__"